import { useState } from 'react';

const faqs = [
  {
    q: '桔子视频需要注册或付费吗？',
    a: '完全不需要。桔子视频所有内容均为免费提供，无需注册账号，无需支付任何费用，打开网站即可直接观看西瓜视频、丝瓜视频等平台的高清影视内容。',
  },
  {
    q: '为什么桔子视频播放不缓冲、不卡顿？',
    a: '我们采用了智能多线分发加速技术，自动为您匹配最优播放线路。同时，桔子视频的片源经过优化编码处理，在保证高清画质的前提下大幅降低带宽需求，让您畅享丝滑观影体验。',
  },
  {
    q: '桔子视频的片源更新频率如何？',
    a: '桔子视频每日自动同步西瓜视频和丝瓜视频的最新内容。热播剧集更新后通常在一小时内即可在本站观看，确保您不错过任何精彩剧情，追剧永远快人一步。',
  },
  {
    q: '在手机或平板上可以正常观看吗？',
    a: '当然可以。桔子视频全面适配移动端浏览，无论是在手机、平板还是电脑上，都能获得流畅的高清观影体验。移动端页面针对触屏操作进行了专门优化。',
  },
  {
    q: '桔子视频支持哪些类型的视频内容？',
    a: '桔子视频聚合了电视剧、电影、综艺、动漫、纪录片和短剧等全品类视频内容，覆盖西瓜视频和丝瓜视频两大平台的热门资源。无论您喜欢什么类型，都能在这里找到想看的内容。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            常见问题
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">你关心的，这里都有答案</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            关于桔子视频的使用、片源、播放体验等常见疑问解答。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden cursor-pointer"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <div className="flex items-center justify-between p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className={`w-6 h-6 shrink-0 flex items-center justify-center transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}